import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsCallInTypeUpdate } from "store/actions"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import FormLabel from "@material-ui/core/FormLabel"
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Radio from "@material-ui/core/Radio";
// import Checkbox from "@material-ui/core/Checkbox";

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
// import DeleteForeverIcons from "@material-ui/icons/DeleteForever";
// import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
// import Switch from "@material-ui/core/Switch";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  }
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageName:"การโทรเข้า-หมวดหมู่",
      _id:null,
      code: "",
      description: "",
      rowCurrentData:{},
    }
  }
  componentWillUpdate(nextProps, nextState) {
      if(nextProps.currentData && nextProps.currentData !== nextState.rowCurrentData){
        this.setState({
          rowCurrentData: nextProps.currentData,
          _id:nextProps.currentData._id,
          code: nextProps.currentData.code,
          description: nextProps.currentData.description,
        })
      }else if(nextProps.currentData === null && this.state._id !== null){
        this.setState({
          rowCurrentData: {},
          _id:null,
          code: "",
          description: "",
        })
      }
  }
 
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleSubmit = () => {
    if( this.state.description === ""){
      ErrorsCallback("ต้องการข้อมูล : ชื่อสถานะหลัก")
    }else{
      if(this.state._id){
        // แก้ไข =============
        const dataToSend = {
          statusId:this.state._id,
          description: this.state.description
        }
    
        APIPost( UrlServer.URL_POST_EDIT_CALL_IN_TYPE,dataToSend,(datas)=>{
          SuccessCallback(datas.message,null,()=>{
            this.props.listsCallInTypeUpdate(true)
          })
        })

      }else{
        // สร้างใหม่ ==========
        const dataToSend = {
          description: this.state.description
        }
    
        APIPost( UrlServer.URL_POST_ADD_CALL_IN_TYPE,dataToSend,(datas)=>{
          this.setState({
            description: ""
          },()=>{
            SuccessCallback(datas.message,null,()=>{
              this.props.listsCallInTypeUpdate(true)
            })
            
          })
        })
      }
    }
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                {
                  ((this.state._id)?
                  <EditIcon />
                  :
                  <AddCircleIcon />
                  )
                }
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                {
                  ((this.state._id)?
                  "แก้ไขข้อมูลสถานะหลัก " + " ID:"+this.state._id
                  :
                  "ฟอร์มการสร้างสถานะหลัก"
                  )
                }
                  
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อสถานะหลัก
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.description,
                          // placeholder: "โครงการเทส ทั่วโลก",
                          onChange: this.handleChangeState("description")
                        }}
                        helpText={(<span className="txt-c-r">* จำเป็นต้องใส่</span>)}
                      />
                    </GridItem>
                  </GridContainer>
                  
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9} lg={10}>
                      <Button
                        color={(this.state._id)?"warning":"success"}
                        className={classes.mt4}
                        onClick={this.handleSubmit}
                      >
                        <CloudUploadIcon className={classes.icons} />
                        {(this.state._id)?"บันทึกการแก้ไข":"บันทึกการสร้าง"}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
function mapStateToProps({ listsCallInType }) {
  return {
    listsCallInType: listsCallInType
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsCallInTypeUpdate }
  )
)(ProjectCreateAndEditManagement)
